import type { Component } from 'vue';
import type { DefaultsInstance } from 'vuetify';
import { VCard, VExpansionPanels, VTextField } from 'vuetify/components';

export const aliases: Record<string, Component> = {
  VTextReadOnly: VTextField,
  VCardContainer: VCard,
  VExpansionPanelsSpaced: VExpansionPanels
};

export const defaults: DefaultsInstance = {
  VBtn: {
    variant: 'flat'
  },
  VRadioGroup: {
    color: 'primary',
    hideDetails: 'auto'
  },
  VSelect: {
    variant: 'outlined',
    density: 'compact',
    color: 'primary',
    itemColor: 'primary',
    hideDetails: 'auto',
    menuIcon: '$expand',
    listProps: {
      density: 'compact'
    },
    VChip: {
      color: 'primary',
      variant: 'tonal'
    }
  },
  VAutocomplete: {
    variant: 'outlined',
    density: 'compact',
    color: 'primary',
    itemColor: 'primary',
    hideDetails: 'auto',
    menuIcon: '$expand',
    listProps: {
      density: 'compact'
    },
    VChip: {
      color: 'primary',
      variant: 'tonal'
    }
  },
  VTextField: {
    variant: 'outlined',
    color: 'primary',
    hideDetails: 'auto',
    density: 'compact',
    flat: true
  },
  VTextReadOnly: {
    hideDetails: true,
    readonly: true,
    bgColor: 'surface'
  },
  VCheckbox: {
    color: 'primary',
    hideDetails: 'auto',
    density: 'compact'
  },
  VSwitch: {
    color: 'primary',
    hideDetails: 'auto',
    density: 'compact',
    inset: true
  },
  VTextarea: {
    variant: 'outlined',
    color: 'primary',
    hideDetails: 'auto',
    density: 'compact'
  },
  VAlert: {
    density: 'comfortable'
  },
  VIconBtn: {
    sizes: [
      ['x-small', 24],
      ['small', 30],
      ['default', 38],
      ['large', 48],
      ['x-large', 56]
    ],
    iconSizes: [
      ['x-small', 16],
      ['small', 18],
      ['default', 20],
      ['large', 22],
      ['x-large', 32]
    ],
    size: 'default'
  },
  VSnackbar: {
    location: 'bottom right',
    contentProps: {
      class: 'my-3 mx-4'
    },
    VBtn: {
      size: 'small'
    }
  },
  VChip: {
    label: true
  },
  VProgressLinear: {
    color: 'primary',
    height: 8,
    rounded: 'pill',
    bgColor: 'track',
    roundedBar: true
  },
  VTabs: {
    color: 'primary',
    height: 38
  },
  VTab: {
    minWidth: 70,
    variant: 'text'
  },
  VSlider: {
    color: 'primary',
    hideDetails: 'auto',
    thumbSize: 22,
    trackSize: 4,
    evaluation: 4
  },
  VCard: {
    VCardActions: {
      VBtn: {
        slim: false
      }
    }
  },
  VPagination: {
    activeColor: 'primary',
    showFirstLastPage: true,
    variant: 'tonal',
    rounded: 'xl'
  },
  VCardContainer: {
    border: true,
    elevation: 0,
    class: 'pa-3'
  },
  VOtpInput: {
    height: 40,
    variant: 'outlined'
  },
  VExpansionPanelsSpaced: {
    class: 'expansion-panel-custom-rounded',
    hideDetails: 'auto',
    elevation: 0,
    VExpansionPanel: {
      class: 'border'
    }
  },
  VTreeview: {
    VListItem: {
      rounded: true
    }
  }
};
